import moment from 'moment';

export default class TimelineRenderHelper {
    static formatTimelineInstanceDateShift(weekendDateShift, holidayDateShift, exclude) {
        return (weekendDateShift || holidayDateShift) && !exclude
            ? `*DUE TO${weekendDateShift ? ' WEEKEND' : ''}${weekendDateShift && holidayDateShift ? ' AND' : ''}${
                  holidayDateShift ? ' HOLIDAY' : ''
              }*`
            : '';
    }

    static formatTimelineInstanceDate(deadlineCalculated, exclude) {
        return exclude ? 'N/A' : moment(deadlineCalculated).format('L');
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-render-helper.js